module.exports = __webpack_public_path__ + "img/vector.37c49b06.svg";